<mat-card class="app-card ">
  <mat-card-header fxLayout="column" class="app-card-header">
    <div class="app-card-title-container" fxLayout="row" fxLayoutAlign="space-between center">
      <mat-card-title class="mat-subtitle-1 app-card-title">{{ title }}</mat-card-title>
      <span fxLayout="row" fxLayoutAlign="center center">
      <mat-icon>more_vert</mat-icon>
      <div class="app-card-avatar">
          <mat-icon class="app-card-avatar-icon">{{ iconName }}</mat-icon>
      </div>
    </span>
    </div>
    <div class="full-width" fxLayout="row" fxLayoutAlign="start center">
      <mat-card-subtitle class="mat-body app-card-subtitle" fxLayout="row">{{ subtitle }}</mat-card-subtitle>
    </div>
  </mat-card-header>
  <mat-card-content class="full-width app-card-content">
    <ng-content select="[appCardContent]"></ng-content>
  </mat-card-content>
  <mat-card-actions class="full-width app-card-actions">
    <ng-content select="[appCardActions]"></ng-content>
  </mat-card-actions>
</mat-card>
